/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { AddToBasketFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { AddToBasketFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import deepmerge from 'deepmerge';
import { rest } from 'msw';
import { addToBasketLayerDataMock } from '../AddToBasketLayer/mockdata';
import { useAddToBasketTrackingDataMock } from '../Tracking/hooks/useAddToBasketTracking/mockdata';

export const addToBasketButtonDataMock: AddToBasketFragmentFragment = {
  ' $fragmentRefs': {
    AddToBasketLayerFragmentFragment: addToBasketLayerDataMock,
    AddToBasketTrackingFragmentFragment: useAddToBasketTrackingDataMock,
  },
  akl: 'AKLBB628362489',
  sku: '7353915077-0-1678589701',
  marketcode: 220,
  availability: {
    state: 'AVAILABLE',
    isOrderable: true,
  },
  price: {
    currency: 'EUR',
    value: 51472,
    valueOld: null,
    saving: {
      value: 21428,
    },
  },
};

export function getAddToBasketButtonFragmentedData(data?: AddToBasketFragmentFragment) {
  return makeFragmentData(data || addToBasketButtonDataMock, AddToBasketFragmentFragmentDoc);
}

export const addToBasketButtonDataMockUnselected = deepmerge(addToBasketButtonDataMock, {
  availability: {
    isOrderable: false,
    state: 'UNSELECTED',
  },
});

export const addToBasketButtonDataMockNotAvailable = deepmerge(addToBasketButtonDataMock, {
  availability: {
    isOrderable: false,
    state: 'NOT_AVAILABLE',
  },
});

export const addToBasketErrorHandler = [
  rest.put('/api/checkout/v1/', (_, res, ctx) => res(ctx.status(500))),
];
